/* NCS native selling plans (Shopify subscriptions via Recharge): subscription add to cart with selling_plan, cart display fixes, frequency dropdown tidy. Debug: window.__ncsDebug. Remove: delete this file and its script tag in snippets/snippet-global-products-json.liquid. */
(function () {
  var OPEN_CART_KEY = 'ncs-open-cart';
  var debug = window.__ncsDebug = { patches: 0, rows: 0, items: 0, matched: [], error: '', refresh: '' };

  function fetchCart() {
    return fetch('/cart.js?ncs=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) { return response.json(); });
  }

  var styleEl = document.createElement('style');
  styleEl.setAttribute('data-ncs-selling-plans', 'true');
  styleEl.textContent = [
    '.c-cart__dropdown{display:none !important;}',
    '.c-shop-logic-purchase-option__footer{display:flex !important;align-items:center !important;flex-wrap:nowrap !important;gap:12px;}',
    '.c-shop-logic-purchase-option__footer-title{white-space:nowrap !important;flex:0 0 auto !important;margin:0 !important;}',
    '.c-shop-logic-purchase-option__select-wrapper{flex:1 1 auto !important;width:auto !important;min-width:0 !important;max-width:100% !important;}',
    '.c-shop-logic-purchase-option__select{width:100% !important;min-width:0 !important;max-width:100% !important;padding-right:38px !important;text-overflow:ellipsis;}',
    '.ncs-plan-info{margin:6px 0 2px;}',
    '.ncs-plan-info p{margin:0;font-size:12px;line-height:1.4;color:#0032c8;}',
    '.ncs-plan-info .ncs-plan-badge{font-weight:700;text-transform:uppercase;letter-spacing:0.03em;}'
  ].join('\n');
  document.head.appendChild(styleEl);

  function weeksFromName(name) {
    var match = String(name).match(/(\d+)\s*-?\s*weeks?/i);
    return match ? parseInt(match[1], 10) : null;
  }

  function frequencyLabel(name) {
    var weeks = weeksFromName(name);
    if (weeks === null) return String(name).split('Delivery every').join('Every').trim();
    return 'Every ' + weeks + (weeks === 1 ? ' week' : ' weeks');
  }

  function tidyFrequencyLabels() {
    var selects = document.querySelectorAll('.js-shop-logic-frequency');
    for (var s = 0; s < selects.length; s++) {
      var select = selects[s];
      var entries = [];
      var allParsed = true;
      for (var i = 0; i < select.options.length; i++) {
        var option = select.options[i];
        var weeks = weeksFromName(option.textContent);
        if (weeks === null) allParsed = false;
        entries.push({ el: option, weeks: weeks });
        option.textContent = frequencyLabel(option.textContent);
      }
      if (allParsed && entries.length > 1) {
        entries.sort(function (a, b) { return a.weeks - b.weeks; });
        for (var j = 0; j < entries.length; j++) select.appendChild(entries[j].el);
        select.selectedIndex = 0;
      }
    }
  }

  function getProduct(productId) {
    var list = window.GLOBAL_PRODUCTS || [];
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(productId)) return list[i];
    }
    return null;
  }

  function resolveVariantId(wrap, btn) {
    var product = getProduct(wrap.getAttribute('data-product-id'));
    if (!product) return null;
    var variants = product.variants || [];
    var active = wrap.querySelectorAll('.js-shop-logic-variant-option.active');
    var values = [];
    var i;
    for (i = 0; i < active.length; i++) values.push(active[i].getAttribute('data-id'));
    if (values.length) {
      var key = values.join(',');
      for (i = 0; i < variants.length; i++) {
        if (variants[i].variantOptionsValues === key) return variants[i].idVariant;
      }
    }
    var current = String(btn.getAttribute('data-product-id'));
    for (i = 0; i < variants.length; i++) {
      if (String(variants[i].idVariant) === current || String(variants[i].idVariantSubscription) === current) {
        return variants[i].idVariant;
      }
    }
    if (variants.length === 1) return variants[0].idVariant;
    return null;
  }

  function reloadAndOpenCart() {
    try { window.sessionStorage.setItem(OPEN_CART_KEY, '1'); } catch (err) {}
    window.location.reload();
  }

  function getCartVm() {
    var cartEl = document.getElementById('js-cart');
    var vm = cartEl && cartEl.__vue__;
    if (!vm) return null;
    var root = vm.$root || vm;
    if ('cartData' in vm && 'isCartOpen' in vm) return vm;
    if ('cartData' in root && 'isCartOpen' in root) return root;
    return null;
  }

  function refreshCartInPlace() {
    return fetchCart()
      .then(function (cart) {
        var vm = getCartVm();
        if (!vm) { debug.refresh = 'no cart vm'; return false; }
        vm.cartData = cart;
        if ('cartDataLength' in vm) {
          try { vm.cartDataLength = cart.item_count; } catch (err) {}
        }
        vm.isCartOpen = true;
        return new Promise(function (resolve) {
          setTimeout(function () {
            var rows = document.querySelectorAll('#js-cart .c-cart__items-added .c-cart__item');
            var ok = rows.length === (cart.items || []).length;
            debug.refresh = ok ? 'ok' : 'row count mismatch ' + rows.length + ' vs ' + (cart.items || []).length;
            resolve(ok);
          }, 800);
        });
      })
      .catch(function (err) { debug.refresh = 'error ' + (err && err.message); return false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.js-add-to-cart.js-shop-logic-btn') : null;
    if (!btn) return;
    var wrap = btn.closest('.js-shop-logic');
    if (!wrap || wrap.getAttribute('data-purchase-option') !== 'SUBSCRIPTION') return;
    if (wrap.classList.contains('oos')) return;

    var select = wrap.querySelector('.js-shop-logic-frequency');
    var sellingPlanId = select ? select.value : '';
    var variantId = resolveVariantId(wrap, btn);
    if (!sellingPlanId || !variantId) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.disabled) return;
    btn.disabled = true;

    var quantity = parseInt(btn.getAttribute('data-product-quantity'), 10) || 1;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: quantity, selling_plan: Number(sellingPlanId) }]
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error((data && (data.description || data.message)) || 'Could not add subscription to cart.');
          });
        }
        return response.json();
      })
      .then(function () {
        return refreshCartInPlace().then(function (updated) {
          if (updated) {
            btn.disabled = false;
            schedulePatch();
          } else {
            reloadAndOpenCart();
          }
        });
      })
      .catch(function (err) {
        btn.disabled = false;
        window.alert(err && err.message ? err.message : 'Could not add subscription to cart.');
      });
  }, true);

  function openCartIfFlagged() {
    var flagged = null;
    try { flagged = window.sessionStorage.getItem(OPEN_CART_KEY); } catch (err) {}
    if (!flagged) return;
    try { window.sessionStorage.removeItem(OPEN_CART_KEY); } catch (err) {}

    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var cartEl = document.getElementById('js-cart');
      var vm = cartEl && cartEl.__vue__;
      var root = vm ? (vm.$root || vm) : null;
      if (root && 'isCartOpen' in root) {
        clearInterval(timer);
        root.isCartOpen = true;
        return;
      }
      if (vm && 'isCartOpen' in vm) {
        clearInterval(timer);
        vm.isCartOpen = true;
        return;
      }
      if (tries > 40) {
        clearInterval(timer);
        var trigger = document.querySelector('.js-cart-trigger:not(.c-cart__overlay)');
        if (trigger) trigger.click();
      }
    }, 150);
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(cents / 100);
  }

  function setText(el, text) {
    if (!el) return;
    var first = el.firstChild;
    if (first && first.nodeType === 3) {
      if (first.nodeValue !== text) first.nodeValue = text;
    } else if (el.textContent !== text) {
      el.textContent = text;
    }
  }

  function discountPercent(alloc) {
    var compare = alloc.compare_at_price;
    var price = alloc.price;
    if (compare && price && compare > price) return Math.round((1 - price / compare) * 100);
    return 0;
  }

  function friendlyPlan(planName) {
    var weeks = weeksFromName(planName);
    if (weeks !== null) return 'Delivered every ' + weeks + (weeks === 1 ? ' week' : ' weeks');
    return planName.split('Delivery every').join('Delivered every');
  }

  function rowTitleText(row) {
    var titleEl = row.querySelector('.c-cart__item-title');
    return titleEl ? titleEl.textContent.trim().toLowerCase() : '';
  }

  function titleMatches(rowTitle, item) {
    if (!rowTitle) return false;
    var productTitle = String(item.product_title || '').toLowerCase();
    var fullTitle = String(item.title || '').toLowerCase();
    if (productTitle && (productTitle.indexOf(rowTitle) !== -1 || rowTitle.indexOf(productTitle) !== -1)) return true;
    if (fullTitle && (fullTitle.indexOf(rowTitle) !== -1 || rowTitle.indexOf(fullTitle) !== -1)) return true;
    return false;
  }

  function matchRowsToItems(rows, items) {
    var used = {};
    var matched = [];
    var i;
    var k;
    for (i = 0; i < rows.length; i++) {
      matched[i] = null;
      var vm = rows[i].__vue__;
      var vmItem = vm && vm.item;
      if (vmItem && vmItem.key) {
        for (k = 0; k < items.length; k++) {
          if (!used[k] && items[k].key === vmItem.key) {
            used[k] = true;
            matched[i] = items[k];
            break;
          }
        }
      }
    }
    for (i = 0; i < rows.length; i++) {
      if (matched[i]) continue;
      var rowTitle = rowTitleText(rows[i]);
      for (k = 0; k < items.length; k++) {
        if (!used[k] && titleMatches(rowTitle, items[k])) {
          used[k] = true;
          matched[i] = items[k];
          break;
        }
      }
    }
    return matched;
  }

  function patchRow(row, item) {
    var alloc = item.selling_plan_allocation;
    var wasPatched = row.getAttribute('data-ncs-patched') === '1';
    var containers = row.querySelectorAll('.c-cart__prices');
    var i;
    for (i = 0; i < containers.length; i++) {
      var container = containers[i];
      var priceEl = container.querySelector('.c-cart__price');
      var del = container.querySelector('del.c-cart__price-compare');
      if (alloc && priceEl) {
        var comparePrice = alloc.compare_at_price || item.original_price;
        setText(priceEl, formatMoney(alloc.price));
        if (!del) {
          del = document.createElement('del');
          del.className = 'c-cart__price-compare ncs-added';
          container.insertBefore(del, priceEl);
        }
        setText(del, formatMoney(comparePrice));
      } else {
        var added = container.querySelector('del.ncs-added');
        if (added && added.parentNode) added.parentNode.removeChild(added);
        if (wasPatched && priceEl) setText(priceEl, formatMoney(item.final_price));
      }
    }
    if (alloc) {
      row.setAttribute('data-ncs-patched', '1');
    } else if (wasPatched) {
      row.removeAttribute('data-ncs-patched');
    }

    var info = row.querySelector('.ncs-plan-info');
    var planName = alloc && alloc.selling_plan && alloc.selling_plan.name ? alloc.selling_plan.name : '';
    if (planName) {
      if (!info) {
        var titleEl = row.querySelector('.c-cart__item-title');
        if (titleEl && titleEl.parentNode) {
          info = document.createElement('div');
          info.className = 'ncs-plan-info';
          info.innerHTML = '<p class="ncs-plan-badge"></p><p class="ncs-plan-detail"></p>';
          var variantDesc = row.querySelector('.c-cart__item-description');
          var anchor = variantDesc ? variantDesc.nextSibling : titleEl.nextSibling;
          titleEl.parentNode.insertBefore(info, anchor);
        }
      }
      if (info) {
        var pct = discountPercent(alloc);
        setText(info.querySelector('.ncs-plan-badge'), pct ? 'Subscribe & Save ' + pct + '%' : 'Subscription');
        setText(info.querySelector('.ncs-plan-detail'), friendlyPlan(planName) + '. Skip or cancel anytime.');
      }
    } else if (info && info.parentNode) {
      info.parentNode.removeChild(info);
    }
  }

  var cartObserver = null;
  var cartRoot = null;
  var patching = false;
  var pendingPatch = false;
  var patchTimer = null;

  function observeCart() {
    if (cartObserver && cartRoot) {
      cartObserver.observe(cartRoot, { childList: true, subtree: true, characterData: true });
    }
  }

  function patchCart() {
    if (patching) { pendingPatch = true; return; }
    var rows = document.querySelectorAll('#js-cart .c-cart__items-added .c-cart__item');
    if (!rows.length) return;
    patching = true;
    fetchCart()
      .then(function (cart) {
        var items = cart.items || [];
        var current = document.querySelectorAll('#js-cart .c-cart__items-added .c-cart__item');
        if (cartObserver) cartObserver.disconnect();
        try {
          var matched = matchRowsToItems(current, items);
          for (var i = 0; i < current.length; i++) {
            if (matched[i]) patchRow(current[i], matched[i]);
          }
          debug.patches++;
          debug.rows = current.length;
          debug.items = items.length;
          debug.matched = matched.map(function (m) { return m ? (m.selling_plan_allocation ? 'sub' : 'one-time') : null; });
          debug.error = '';
        } finally {
          observeCart();
        }
      })
      .catch(function (err) { debug.error = String(err && err.message ? err.message : err); })
      .then(function () {
        patching = false;
        if (pendingPatch) {
          pendingPatch = false;
          schedulePatch();
        }
      });
  }

  function schedulePatch() {
    clearTimeout(patchTimer);
    patchTimer = setTimeout(patchCart, 150);
  }

  function initCartPatching() {
    cartRoot = document.getElementById('js-cart');
    if (!cartRoot || !window.MutationObserver) return;
    cartObserver = new MutationObserver(schedulePatch);
    observeCart();
    schedulePatch();
    setTimeout(schedulePatch, 1200);
    setTimeout(schedulePatch, 3000);
    setInterval(function () {
      var el = document.getElementById('js-cart');
      if (el && (el.classList.contains('active') || el.classList.contains('b-cart')) && el.querySelector('.c-cart__item')) {
        schedulePatch();
      }
    }, 1500);
  }

  function init() {
    tidyFrequencyLabels();
    initCartPatching();
    openCartIfFlagged();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();